import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'fc-header-ui',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class HeaderComponent {}
